export function waLink(number, text) {
  const clean = (number || "").replace(/[^0-9]/g, "");
  return `https://wa.me/${clean}?text=${encodeURIComponent(text)}`;
}

export function telHref(phone) {
  let n = (phone || "").replace(/[^0-9+]/g, "");
  if (n.startsWith("0")) n = "+44" + n.slice(1);
  else if (n && !n.startsWith("+")) n = "+" + n;
  return `tel:${n}`;
}

export function fmtPrice(p) {
  if (p == null || p === "" || isNaN(p)) return null;
  return `£${Math.round(Number(p))}`;
}

export function vehicleName(v) {
  return `${v.year} ${v.make} ${v.model}`;
}

export const waMessages = {
  general: () =>
    "Hi, I'm looking for a Manchester licensed PHV vehicle to rent. What cars do you currently have available?",
  withInsurance: () =>
    "Hi, I'm looking for a Manchester PHV rental with insurance. What vehicles do you currently have available?",
  withoutInsurance: () =>
    "Hi, I'm looking for a Manchester PHV rental without insurance. What vehicles do you currently have available?",
  vehicle: (v) => {
    const price = v.weekly_price_without_insurance
      ? ` for £${Math.round(v.weekly_price_without_insurance)}/week`
      : "";
    return `Hi, I'm interested in the ${vehicleName(v)} advertised on your website${price}. Is it still available?`;
  },
  rented: (v) =>
    `Hi, I saw the ${vehicleName(v)} on your website but it is currently rented. What similar PHV vehicles do you have available?`,
  requirements: () =>
    "Hi, I'd like to rent a Manchester PHV. Can you explain the requirements to rent a vehicle?",
};

export const AVAILABILITY_LABEL = {
  available: "Available Now",
  coming_soon: "Coming Soon",
  rented: "Currently Rented",
  hidden: "Hidden",
};
